import React from 'react';
import {connect} from 'react-redux';
import {BaseUsedTeams} from 'components/organisms/used-teams/components/sports/lol';
import {calcPercentage} from 'helpers/common-helper';

class UsedTeamsComponent extends BaseUsedTeams {
    render() {
        const {lineups} = this.props;

        if (isEmpty(lineups.all())) {
            return null;
        }

        const lineupsList = lineups.all();
        let teamList = this.groupTeamUsage(lineupsList);
        teamList = this.prepareTeams(teamList);
        let countLineups = Object.keys(lineupsList).length;
        let usedTeams = [];

        if (countLineups > 0) {
            Object.values(teamList).map((team, index) => {
                const percentage = calcPercentage(countLineups, team.usedLineupsCount);
                const className = index % 2 === 0 ? 'even' : '';

                usedTeams.push(
                    <tbody key={index} className={className}>
                        <tr>
                            <td>
                                <strong>{team.name}</strong>
                            </td>
                            <td className="text-blue">
                                <span className="percent-in inline-text">{percentage}%</span>({team.usedLineupsCount})
                            </td>
                        </tr>
                    </tbody>,
                );
            });
        } else {
            usedTeams.push(this.getNotFoundView());
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>Team</th>
                                <th>Exp%</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{usedTeams}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineups} = state.lineupsData;
    return {
        lineups,
    };
}

let UsedTeams = connect(mapStatesToProps)(UsedTeamsComponent);

export {UsedTeams};
